import {atom} from 'jotai'

import {Product} from '../domain'

const initialProduct: Product = {
  productName: '',
  sku: '',
  description: '',
  barcode: '',
  productType: '',
  purchaseTypeID: '',
  productSubCategoryID: '',
  visibilityList: [],
  statusID: 1,
  productCategoryID: '',
  publishDate: '',
  endDate: '',
  image: null,
  media: [],
  price: 0,
  payWithPoints: false,
  eligibleForPoints: false,
  eligibleForDiscount: false,
  approvedProduct: false,
  seasonal: false,
  infoContentData: [],
}

export const detailAtom = atom<Product>(initialProduct)

export const categoriesAtom = atom<
  {
    id: string
    name: string
  }[]
>([])

export const familysAtom = atom<
  {
    id: string
    name: string
  }[]
>([])

export const visibilitysAtom = atom<
  {
    id: string
    name: string
  }[]
>([])
